import * as rewardBlocks from "@lts/reward-blocks/legacy/legacy";

export { rewardBlocks };
export default rewardBlocks;
